import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=61fe8230&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaskTable.vue"
export default component.exports